module.exports = __webpack_public_path__ + "img/user.b49283f8.svg";